import { ProjectsActions } from './projects.actions';

export const initialState = {
  projects: [],
  archive: [],
};

export function ProjectsReducer(state: any = initialState, action) {

  switch (action.type) {
    case ProjectsActions.ADD_OR_UPDATE_PROJECT:

      const idx = state.projects.findIndex((project) => {
        return project.id === action.payload.project.id || project.projectId === action.payload.project.id;
      });

      if (idx !== -1) {
        state.projects[idx] = action.payload.project;
      } else {
        state.projects.push(action.payload.project);
      }

      return state;

    case ProjectsActions.SYNC_PROJECT:

      // todo
      for (let projectIndex in state.projects) {
        if (state.projects[projectIndex].saved === action.payload.saved &&
          state.projects[projectIndex].id === action.payload.id) {
          state.projects[projectIndex] = action.payload.project;
          return state;
        }
      }
      return state;

    case ProjectsActions.ADD_MISS_ACTIVE_PROJECTS:
      for (let projectIndex in state.projects) {
        for (let syncProjectIndex in action.payload.projects) {
          if (state.projects[projectIndex].saved === action.payload.projects[syncProjectIndex].saved &&
            state.projects[projectIndex].id === action.payload.projects[syncProjectIndex].id) {
            action.payload.projects.splice(syncProjectIndex, 1);
          }
        }
      }
      state.projects = state.projects.concat(action.payload.projects);
      return state;

    case ProjectsActions.ADD_MISS_ARCHIVE_PROJECTS:
      for (let archiveIndex in state.archive) {
        for (let syncProjectIndex in action.payload.projects) {
          if (state.archive[archiveIndex].saved === action.payload.projects[syncProjectIndex].saved &&
            state.archive[archiveIndex].id === action.payload.projects[syncProjectIndex].id) {
            action.payload.projects.splice(syncProjectIndex, 1);
          }
        }
      }
      state.archive = state.archive.concat(action.payload.projects);
      return state;

    case ProjectsActions.REMOVE_ACTIVE_PROJECT:
      for (let projectIndex in state.projects) {
        if (state.projects[projectIndex].saved === action.payload.project.saved &&
          state.projects[projectIndex].id === action.payload.project.id) {
          state.projects.splice(projectIndex, 1);
          return state;
        }
      }
      return state;

    case ProjectsActions.REMOVE_ARCHIVE_PROJECT:
      for (let archiveIndex in state.archive) {
        if (state.archive[archiveIndex].saved === action.payload.project.saved &&
          state.archive[archiveIndex].id === action.payload.project.id) {
          state.archive.splice(archiveIndex, 1);
          return state;
        }
      }
      return state;

    case ProjectsActions.ACTIVATE_PROJECT:
      state.projects.push(action.payload.project);
      return state;

    case ProjectsActions.ARCHIVE_PROJECT:
      state.archive.push(action.payload.project);
      return state;

    case ProjectsActions.DELETE_PROJECT_MONSTER:
      const projects = state.projects.map((project) => {
        if (project.id === action.payload.projectId) {
          project.projectFormMonsters.fields.monsters = project.projectFormMonsters.fields.monsters.filter((monster) => {
            return monster.id !== action.payload.monsterId;
          })
        }
        return project;
      });
      return { ...state, projects: projects };

    case ProjectsActions.DELETE_PROJECT:
      const archive = state.archive.filter((project) => {
        return project.id !== action.payload.projectId;
      });
      return { ...state, archive: archive };

    case ProjectsActions.DELETE_ALL:
      return { ...initialState };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/states/projects/projects.reducer.ts